/* istanbul ignore file */

import { handleFetchResponse } from '@noths/polaris-client-utils';
import fetch from 'isomorphic-unfetch';
import getConfig from 'next/config';

import { NextConfig } from 'src/types/NextConfig';
import { RichRelevanceProduct } from '../../types/RichRelevance';
import { RecommendationsServiceProductData } from './types';

const {
  publicRuntimeConfig: { RECOMMENDED_PRODUCTS_API_URL },
} = getConfig() as NextConfig;

export const getProductsFromRecommendationsService = async (items: RichRelevanceProduct[]) => {
  const ids = items.map((p) => p.id).join('&ids[]=');
  const apiResponse = await fetch(`${RECOMMENDED_PRODUCTS_API_URL}?ids[]=${ids}`);

  try {
    const { products } = ((await handleFetchResponse(apiResponse)) || {}) as Record<
      'products',
      RecommendationsServiceProductData[]
    >;

    return products;
  } catch (error) {
    return Promise.reject(error);
  }
};
